<template>
    <div class="home">
        <FlightHeader :hideLogo="true" />
        <div class="fullpage-section">
            <div class="flightschool-intro container">
                <img class="question-sticker positionX-left positionY-none" src="/question_assets/0001_Pillar_Image_Cloud.png" />
                <img class="question-sticker positionX-right positionY-below" src="/question_assets/0001_Pillar_Image_Cloud.png" />
                <div class="row">
                    <div class="col col-xs-12 col-md-8">
                        <img class="intro-logo" src="./../assets/FlightSchool_Logo_DDFF00.png" />
                        <h4>Flight School is temporarily closed.<br><br>We hope to be back in the fall. Until then, remember: Nobody puts your creativity in a quarantine. <a href="https://instagram.com/swift_flightschool">Follow us</a> for updates. And keep your mind infinitely occupied with these thought-starters.</h4>
                    </div>
                </div>
                <div class="scrollhint">
                    <div class="downarrow"></div>
                </div>
            </div>
        </div>
        <!-- <div class="job-descriptions">
            <div class="flightschool-descriptions container">
                <div class="row">
                    <h4 class="col-12">Open roles<br>Summer 2020</h4>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-3">
                        <h5>Copywriter<br>Intern</h5>
                        <p>You're a wordsmith of scripts, tweets and manifestos. Your pen ink runs out faster than a bottle of sriracha. Even so, you can translate words from paper to people because of your excellent communication skills. You know you can't say the same thing to everyone, so you finesse tone and language for different platforms and people.</p>
                    </div>
                    <div class="col-xs-12 col-md-3">
                        <h5>Art Director<br>Intern</h5>
                        <p>You have an eye (or two) for visual detail. You can effectively and confidently communicate the crazy rainbow rabbit hole of your conceptual mind so everyone sees what you're seeing. When people STILL don't get it, you use your proficiency in G Suite, Mac OSX, InDesign, Illustrator, Photoshop and Acrobat to spell it out with a picture.</p>
                    </div>
                    <div class="col-xs-12 col-md-3">
                        <h5>Designer<br>Intern</h5>
                        <p>You're an expert of craft. Not just a thinker, but a creator. Not just a problem solver, but a beautiful solution maker. Photoshop, Illustrator and InDesign (and maybe After Effects) aren't just your tools, they're an extension of yourself. Your portfolio proves your digital concepts, creative design solutions and unique skills.</p>
                    </div>
                    <div class="col-xs-12 col-md-3">
                        <h5>Data Scientist<br>Intern</h5>
                        <p>Data is your passion and your blood just might be binary. You dig deep into numbers and pull out hidden consumer needs, identify emerging social trends and find meaningful insights for clients. Python, R, SQL, Tableau, Google Data Studio, D3.Js, MongoDB, Redshift, are the ways you turn data into meaningful stories.</p>
                    </div>
                </div>
            </div>
        </div> -->
        <form class="application" @submit="checkForm">
            <!-- <div class="container" style="margin-top: 20em;">
                <ul class="required-questions">
                    <img class="question-sticker positionX-left positionY-none bleed-true" src="/question_assets/0002_Pillar_Image_Plant.png" />
                    <div class="row">
                        <li class="required-question" v-for="(question, i) in requiredQuestions" :key="question.id">
                            <div v-if="i == 14" class="col-12" style="display: inline-block;"><div class="demographics-disclaimer">To ensure that we understand the diversity of our candidates we ask that you voluntarily respond to the questions below. You are not required to self-identify and your reply will not impact your consideration for employment.<br><br>We are an equal opportunity employer and value diversity at our company. We do not discriminate on the basis of race, religion, color, national origin, gender, sexual orientation, age, marital status, veteran status, or disability status.</div></div>
                            <div v-if="i < (requiredQuestions.length - 3)" class="col-12 col-md-6" style="display: inline-block;"><span>{{ question.title }}</span></div>
                            <div v-else class="col-12 col-md-4" style="display: inline-block;"><span>{{ question.title }}</span></div>

                            <swift-input :demographics="question.demographic" :class="[question.demographic]" :id="question.id" placeholder="Type your answer here" :type="question.type" :value="question.value" v-on:questionAnswered="handleAnswer" :options="question.options" :required="question.required" :actuallyRequired="question.actuallyRequired" />
                        </li>
                    </div>
                </ul>
                <i style="font-size: .7em">* = required</i>
            </div> -->
            <div class="fullpage-section">
                <div class="container other-questions-intro">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-7">
                            <h4>You are entering the realm of infinite possibilities.</h4>
                            <p>The following is designed to showcase your creativity. There are no right or wrong answers or too few or too many answers.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="other-questions">
                <div class="other-question" v-for="question in otherQuestions" :key="question.id">
                    <Question :question="question.title" :options="question.options" :inputName="question.id" :id="question.id" :value="question.value" :orientation="question.align" :questionType="question.type" :belowSpacing="question.belowSpacing" :customClass="question.customClass" :sticker="question.sticker" />
                </div>
            </div>
            <div class="fullscreen-section">
                <div class="flightschool-intro container">
                    <div class="row">
                        <div class="col col-xs-12 col-md-8">
                            <h4>Looks like you've outpaced the rate at which the void of infinity is constantly expanding.<br><!-- <br>All that's left is to submit. --></h4>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <!-- <div class="container-fluid sticky-footer">
                <div class="submitbutton" :class="['submitready-' + submitReady]" @click="submitConfirm">SUBMIT?</div>
            </div> -->
            <!-- <Modal modalType="submit" :enabled="submitConfirmBool" v-on:closeSubmitConfirm="closeSubmitConfirm" />
            <Modal modalType="dsWarning" :enabled="dsSelectedBool" v-on:closeSubmitConfirm="closeDsWarning" />
            <Modal modalType="formError" :enabled="hasFormErrors" :errors="formErrors" v-on:closeSubmitConfirm="closeFormErrors" />
            <Modal modalType="confirmation" :enabled="formSubmittedWindow" v-on:closeSubmitConfirm="closeConfirmation" /> -->
        </form>
    </div>
</template>

<style lang="scss" scoped>
.home {
    background-image: linear-gradient(#0000C6, #F283A9, #b5c030, #007CFF, #9D2FA3, #F7B2E6, #00C58E, #b5c030, #007CFF, #F283A9, #b5c030, #007CFF, #9D2FA3, #F7B2E6, #00C58E, #b5c030, #007CFF, #9D2FA3, #F7B2E6, #00C58E, #b5c030, #007CFF, #9D2FA3, #F7B2E6, #00C58E, #b5c030, #007CFF, #9D2FA3, #F7B2E6, #00C58E, #b5c030, #0000C6)
}
</style>

<script>
import FlightHeader from '@/components/FlightHeader';
import Question from '@/components/Question';
// import SwiftInput from '@/components/SwiftInput';
import Footer from '@/components/Footer'
// import Modal from '@/components/Modal'

import { requiredQuestions, otherQuestions } from "../questionnaire/questions.js";

// check local storage on first load and get the answers
export default {
    name: "Home",
    components: {
        FlightHeader,
        Question,
        // SwiftInput,
        Footer,
        // Modal
    },
    data: () => ({
        requiredQuestions,
        otherQuestions,
        submitReady: false,
        submitConfirmBool: false,
        dsSelectedBool: false,
        formErrors: [],
        hasFormErrors: false,
        scrollTop: window.scrollY,
        formSubmittedWindow: false,
        formSubmitted: "false"
    }),
    created: function () {
        // check sessionStorage to see if answers are inside
        if (sessionStorage.getItem("requiredQuestions") === null) {
            sessionStorage.setItem("requiredQuestions", JSON.stringify(this.requiredQuestions));
        } else {
            const localRequiredAnswers = sessionStorage.getItem("requiredQuestions");
            this.requiredQuestions = JSON.parse(localRequiredAnswers);
        }

        if (sessionStorage.getItem("otherQuestions") === null) {
            sessionStorage.setItem("otherQuestions", JSON.stringify(this.otherQuestions));
        } else {
            const localOtherAnswers = sessionStorage.getItem("otherQuestions");
            this.otherQuestions = JSON.parse(localOtherAnswers);
        }

        if (sessionStorage.getItem("submitted") === null) {
            sessionStorage.setItem("submitted", "false");
        } else {
            this.formSubmitted = sessionStorage.getItem("submitted")
        }

        if (this.submitReadyChecker()) {
            this.submitReady = true;
        } else {
            this.submitReady = false;
        }

        document.querySelector('.sticky-marquee').classList.remove('sticky-marquee-hidden')
        document.querySelector('.sticky-progressbar').classList.remove('sticky-progressbar-hidden')

        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll: function() {
            // if (window.scrollY > this.scrollTop) {
            //     if (!document.querySelector('.sticky-marquee').classList.contains('sticky-marquee-temphide')) { document.querySelector('.sticky-marquee').classList.add('sticky-marquee-temphide') }
            // } else {
            //     if (document.querySelector('.sticky-marquee').classList.contains('sticky-marquee-temphide')) { document.querySelector('.sticky-marquee').classList.remove('sticky-marquee-temphide') }
            // }
            this.scrollTop = window.scrollY;

            var progressBarEl = document.querySelector('.sticky-progressbar');
            if (window.innerWidth >= 1200) {
                if (window.scrollY >= 3400) {
                    if (!progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.add('sticky-progressbar-shown') }
                } else {
                    if (progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.remove('sticky-progressbar-shown') }
                }
            } else if (window.innerWidth >= 992) {
                if (window.scrollY >= 3700) {
                    if (!progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.add('sticky-progressbar-shown') }
                } else {
                    if (progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.remove('sticky-progressbar-shown') }
                }
            } else if (window.innerWidth >= 768) {
                if (window.scrollY >= 4000) {
                    if (!progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.add('sticky-progressbar-shown') }
                } else {
                    if (progressBarEl.classList.contains('sticky-progressbar-shown')) { progressBarEl.classList.remove('sticky-progressbar-shown') }
                }
            }
        },
        submitReadyChecker: function() {
            var actuallyRequiredQuestions = [];
            for (let i = 0; i < this.requiredQuestions.length; i++) {
                if (this.requiredQuestions[i].actuallyRequired) {
                    actuallyRequiredQuestions.push(this.requiredQuestions[i])
                }
            }

            var submitReady = true;
            for (let x = 0; x < actuallyRequiredQuestions.length; x++) {
                if (actuallyRequiredQuestions[x].value == '') {
                    submitReady = false;
                }
            }

            return submitReady;
        },
        submitConfirm: function() {
            if (this.submitReady) {
                this.submitConfirmBool = true;
                document.body.classList.add('noscroll')
            }
        },
        closeSubmitConfirm: function() {
            this.submitConfirmBool = false;
            document.body.classList.remove('noscroll')
        },
        closeConfirmation: function() {
            this.formSubmittedWindow = false;
            document.body.classList.remove('noscroll')
        },
        closeFormErrors: function() {
            this.hasFormErrors = false;
            document.body.classList.remove('noscroll')
        },
        closeDsWarning: function() {
            const previousRequiredQuestions = [...this.requiredQuestions];
            previousRequiredQuestions.find(question => question.id == "position").value = "";
            sessionStorage.setItem("requiredQuestions", JSON.stringify(previousRequiredQuestions));
            this.requiredQuestions = previousRequiredQuestions;

            this.dsSelectedBool = false;
            document.querySelector('input[name=position][value=DS]').checked = false
            if (this.submitReadyChecker(event)) {
                this.submitReady = true;
            } else {
                this.submitReady = false;
            }

            document.body.classList.remove('noscroll')
        },
        handleAnswer: function (event) {
            console.log('handleAnswer Home.vue')
            if (event.required) {
                const previousRequiredQuestions = [...this.requiredQuestions];
                previousRequiredQuestions.find(question => question.id == event.id).value = event.value;
                sessionStorage.setItem("requiredQuestions", JSON.stringify(previousRequiredQuestions));
                this.requiredQuestions = previousRequiredQuestions;

                if (this.submitReadyChecker(event)) {
                    this.submitReady = true;
                } else {
                    this.submitReady = false;
                }
            } else {
                console.log('!event.required Home.vue')
                const previousOtherQuestions = [...this.otherQuestions];
                console.log(previousOtherQuestions)
                previousOtherQuestions.find(question => question.id == event.id).value = event.value;
                sessionStorage.setItem("otherQuestions", JSON.stringify(previousOtherQuestions));
                this.otherQuestions = previousOtherQuestions;
                console.log(this.otherQuestions)
            }
            if (this.requiredQuestions.find(question => question.id == "position").value == "DS") {
                this.dsSelectedBool = true;
                document.body.classList.add('noscroll')
            }
        },
        checkForm: function (e) {
            e.preventDefault();
            const allAnswers = this.requiredQuestions.concat(this.otherQuestions);
            this.formErrors = [];

            if (sessionStorage.getItem('submitted') == "true") {
                this.formErrors.push({field: "Form already submitted"});
                this.closeSubmitConfirm();
                document.body.classList.add('noscroll');
                this.hasFormErrors = true;
                return;
            }

            // phone number validation
            // eslint-disable-next-line no-useless-escape
            if (!(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(allAnswers.find(question => question.id == "phone").value))) {
                this.formErrors.push({field: "Phone Number"});
            }

            // email validation
            // eslint-disable-next-line no-useless-escape
            if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(allAnswers.find(question => question.id == "email").value))) {
                this.formErrors.push({field: "Email"});
            }

            if (this.formErrors.length > 0) {
                this.closeSubmitConfirm();
                document.body.classList.add('noscroll');
                this.hasFormErrors = true;

                return;
            } else {
                this.submitForm(allAnswers);
            }
        },
        submitForm: function(allAnswers) {
            const answers = JSON.stringify(allAnswers);
            console.log('submitForm')
            let that = this;

            let xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function() {
                // 	Check if request is completed
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    //	Do what needs to be done here
                    let response = JSON.parse(xhr.response);
                    console.log(response)
                    if (response.message == "successful" || response.message == "SWIFTTEST was used as first name. Call was successful.") {
                        that.formSubmitted = "true";
                        console.log(this.formSubmitted)
                        that.formSubmittedWindow = true;
                        that.closeSubmitConfirm();
                        document.body.classList.add('noscroll');
                        sessionStorage.setItem("submitted", "true");
                    } else if (response.message == "Candidate already exists") {
                        that.closeSubmitConfirm();
                        that.formErrors.push({field: "Your application already exists."});
                        document.body.classList.add('noscroll');
                        that.hasFormErrors = true;
                        that.formSubmitted = "true";
                        sessionStorage.setItem("submitted", "true");
                    }
                }
            }

            // Set the request URL and request method
            xhr.open("POST", "https://us-central1-swift-flightschool.cloudfunctions.net/addCandidate");
            xhr.setRequestHeader("Content-Type", "application/json");

            // Send the requst with Data
            if (sessionStorage.getItem('submitted') == "false") { xhr.send(answers); }
        }
    }
}
</script>